import React from "react";
import CustomTooltip from "../../../Core/Components/CustomTooltip";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import BatteryPercentageStatus from "../../Battery/phase3/BatteryPercentageStatus";

export const EnergySourceColumn = ({ record }) => {
  return (
    <div className="flex items-center gap-x-1 w-full">
      <div
        className="h-2 rounded-full bg-light-blue"
        style={{ width: record?.storage }}
      />

      <div
        className="h-2 rounded-full bg-green"
        style={{ width: record?.grid }}
      />

      <div
        className="h-2 rounded-full bg-yellow"
        style={{ width: record?.solar }}
      />
    </div>
  );
};

const batteries = [
  {
    id: 1,
    percentage: 20,
    type: "Kawi 1.6.0-DA-AN",
    energy: "0.2 kWh",
  },
  {
    id: 2,
    percentage: 20,
    type: "Kawi 1.6.0-DA-AN",
    energy: "0.2 kWh",
  },
  {
    id: 3,
    percentage: 20,
    type: "Kawi 1.6.0-DA-AN",
    energy: "0.2 kWh",
  },
];

export const BatteriesConnectedColumn = ({ record }) => {
  if (!record?.batteries)
    return (
      <p className="font-aileron text-xs font-semibold text-dark-gray">
        No Batteries Connected
      </p>
    );

  return (
    <CustomTooltip
      trigger="click"
      bgColor="#ffffff"
      tooltipTitle={
        <div className="p-2 rounded-md w-[226px]">
          {batteries.map((item, index) => (
            <div
              key={item.id}
              className={` ${
                index < batteries.length - 1
                  ? "pb-2 mb-2 border-b border-light-grey"
                  : ""
              }`}
            >
              <div className="flex items-center justify-between">
                <BatteryPercentageStatus
                  detail={item}
                  showChargingStatus={false}
                />

                <p className="font-aileron text-xs font-normal text-dark-gray">
                  {item.id}
                </p>
              </div>

              <div className="mt-2 flex items-center justify-between">
                <p className="font-aileron text-xs font-normal text-dark-gray">
                  Type
                </p>

                <p className="font-aileron text-xs font-semibold text-black">
                  {item.type}
                </p>
              </div>

              <div className="mt-2 flex items-center justify-between">
                <p className="font-aileron text-xs font-normal text-dark-gray">
                  Energy
                </p>

                <p className="font-aileron text-xs font-semibold text-black">
                  {item.energy}
                </p>
              </div>
            </div>
          ))}
        </div>
      }
    >
      <div className="flex items-center gap-x-1">
        <p className="font-aileron text-xs font-semibold text-dark-gray">
          {record?.batteries} Batteries
        </p>

        <ChevronIcon className="w-4 h-4 rotate-90 stroke-dark-gray" />
      </div>
    </CustomTooltip>
  );
};
